import { useResourceTree } from './use-resource-tree';

/**
 * ViewModel for the Skills detail file browser. Thin wrapper around the
 * generic `useResourceTree` — same shape Agents uses.
 */
export function useSkillTree(
  skillId: string | null,
  ref: string | null,
  options: { enabled?: boolean } = {},
) {
  return useResourceTree('skill', skillId, ref, { ...options, defaultFile: 'SKILL.md' });
}
